import React, { forwardRef, ReactElement, ReactNode } from 'react'

export type SegmentProps = {
    active: boolean
    onClick?: () => void
    children: ReactNode
    'aria-selected': boolean
}

/**
 * A single button segment within the {@link UiVersionToggle} tab strip.
 * Renders as a styled button with an active/inactive visual state.
 */
export const Segment = forwardRef<HTMLButtonElement, SegmentProps>(function Segment(
    { active, onClick, children, ...rest }: SegmentProps,
    ref
): ReactElement {
    const className: string =
        'ui-version-toggle__segment' + (active ? ' ui-version-toggle__segment--active' : '')

    return (
        <button ref={ref} type='button' role='tab' onClick={onClick} className={className} {...rest}>
            {children}
        </button>
    )
})
